"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const Row_1 = require("../../components/Row");
const FormSection_1 = require("../../../utils/FormSection");
const MessageAndMediaIcon_1 = require("./MessageAndMediaIcon");
const MessageAndMediaNotification_1 = require("./MessageAndMediaNotification");
const PhonePreview_1 = require("../../PhonePreview");
const actions_1 = require("../../../../actions");
const reducers_1 = require("../../../../reducers");
const react_responsive_1 = require("react-responsive");
const NotificationAttachmentPicker_1 = require("./NotificationAttachmentPicker");
const RichMediaSelector_1 = require("./RichMediaSelector");
const RichMediaUpdateButtons_1 = require("./RichMediaUpdateButtons");
class MessageAndMedia extends React.Component {
    constructor(props) {
        super(props);
        const { deliverable } = this.props;
        const { attachment } = deliverable;
        this.state = {
            editingField: '',
            isShowingRichMediaPopover: false,
            isShowingPhonePreview: false,
            phonePreviewAnimation: 'open',
            richMediaAttachmentTab: attachment ? attachment.type : 'IMAGE',
            tempNotificationAttachment: {
                type: attachment ? attachment.type : 'IMAGE',
                url: attachment ? attachment.url : '',
            },
        };
        this.setState = this.setState.bind(this);
    }
    renderBodyLengthBadge(length) {
        const style = {
            textAlign: 'right',
            marginRight: 16,
            marginTop: 8,
        };
        if (length === 0) {
            return;
        }
        if (length < 90) {
            return (React.createElement("div", { style: style },
                React.createElement(src_1.Badge, { color: src_1.green, text: `${length} CHARACTERS` })));
        }
        if (length >= 90 && length < 148) {
            return (React.createElement("div", { style: style },
                React.createElement(src_1.Badge, { color: src_1.yellow, text: `${length} CHARACTERS` })));
        }
        if (length >= 148) {
            return (React.createElement("div", { style: style },
                React.createElement(src_1.Badge, { color: src_1.red, text: `${length} CHARACTERS` })));
        }
    }
    renderPreview() {
        const { device, deliverable } = this.props;
        const { isShowingPhonePreview, phonePreviewAnimation } = this.state;
        const { attachment, body, title = '' } = deliverable;
        const Fragment = React.Fragment;
        if (device === 'Desktop') {
            return (React.createElement(react_responsive_1.default, { minWidth: 1140 }, ReactDOM.createPortal(React.createElement("div", { style: { position: 'absolute', top: 96, left: 24 } },
                React.createElement(MessageAndMediaIcon_1.default, null),
                React.createElement(MessageAndMediaNotification_1.default, { notificationAttachment: attachment, notificationBody: body, notificationTitle: title }, this.renderBodyLengthBadge(body.length))), document.getElementById('phone-bezel'))));
        }
        return (isShowingPhonePreview &&
            ReactDOM.createPortal(React.createElement(PhonePreview_1.default, { animation: `${phonePreviewAnimation} ease-out 400ms`, device: device, buttonLeft: "Close", buttonLeftCallback: () => this.setState({ phonePreviewAnimation: 'close' }, () => setTimeout(() => this.setState({
                    isShowingPhonePreview: false,
                }), 400)), previewTitle: "Preview" },
                React.createElement(Fragment, null,
                    React.createElement(MessageAndMediaIcon_1.default, null),
                    React.createElement(MessageAndMediaNotification_1.default, { notificationAttachment: attachment, notificationBody: body, notificationTitle: title }, this.renderBodyLengthBadge(body.length)))), document.getElementById('mainModalLeft')));
    }
    render() {
        const { device, deliverable, isCurrentPage, updateNotificationDeliverable } = this.props;
        const { editingField, richMediaAttachmentTab, tempNotificationAttachment } = this.state;
        const { body, title = '' } = deliverable;
        const updateTempNotificationAttachmentFields = (tempNotificationAttachment) => this.setState({
            tempNotificationAttachment,
        });
        return (React.createElement(FormSection_1.default, { device: device, style: { marginTop: 24 } },
            React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                React.createElement(src_1.Text, { text: "Message and Media", size: "h1" }),
                device !== 'Desktop' && (React.createElement(src_1.EyeIcon, { fill: src_1.turquoise, onClick: () => this.setState({
                        phonePreviewAnimation: 'open',
                        isShowingPhonePreview: true,
                    }), style: { marginLeft: 8 } }))),
            React.createElement(Row_1.default, { onClick: () => this.setState({ editingField: `body` }) },
                React.createElement(src_1.TextAreaInput, { id: "notification-body-text", size: 'large', rows: 3, cols: 50, isEditingText: editingField === 'body', label: 'Body', placeholder: 'Enter the main notification copy', startEditingText: () => this.setState({ editingField: `body` }), stopEditingText: () => this.setState({ editingField: '' }), text: body, updateText: (notificationBody) => {
                        updateNotificationDeliverable({ body: notificationBody });
                    } })),
            React.createElement(src_1.TextInput, { id: "notification-title-text", deleteText: () => updateNotificationDeliverable({ title: null }), isEditingText: editingField === 'title', label: "Title", media: device, onInputChange: (notificationTitle) => {
                    updateNotificationDeliverable({
                        title: notificationTitle,
                    });
                }, startEditingText: () => {
                    this.setState({ editingField: 'title' });
                }, text: title ? title : '', updateText: (text) => {
                    updateNotificationDeliverable({
                        title: text ? text : undefined,
                    });
                    this.setState({
                        editingField: '',
                    });
                } }),
            React.createElement(NotificationAttachmentPicker_1.default, { device: device, updateEditingField: () => this.setState({
                    editingField: '',
                }), tempNotificationAttachment: tempNotificationAttachment, updateTempNotificationAttachmentFields: updateTempNotificationAttachmentFields },
                React.createElement(RichMediaUpdateButtons_1.default, { device: device, updateTempNotificationAttachmentFields: updateTempNotificationAttachmentFields }),
                React.createElement(RichMediaSelector_1.default, { device: device, isEditingRichMediaURL: editingField === 'url', richMediaAttachmentTab: richMediaAttachmentTab, updateRichMediaAttachmentTab: (richMediaAttachmentTab, editingField) => this.setState({
                        richMediaAttachmentTab,
                        editingField,
                    }), updateEditingField: (editingField, callback) => this.setState({ editingField }, callback), updateTempNotificationAttachmentFields: updateTempNotificationAttachmentFields, tempNotificationAttachment: tempNotificationAttachment })),
            isCurrentPage && this.renderPreview()));
    }
}
const mapStateToProps = (state) => ({
    deliverable: reducers_1.getEditableCampaignDeliverable(state),
    editableUIState: reducers_1.getEditableUIState(state),
});
const mapDispatchToProps = (dispatch) => ({
    updateNotificationDeliverable: (updatedDeliverableFields) => dispatch(actions_1.updateNotificationDeliverable(updatedDeliverableFields)),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(MessageAndMedia);
